import { FileCopy } from '@mui/icons-material';
import { Button, IconButton, List, ListItem, Paper, Tooltip } from '@mui/material';
import { action, observable, runInAction, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import AutotextosService from '../../assistente-minutas/services/AutotextosService';
import Modal from '../../misc/Modal';
import MensagemStore from '../../store/MensagemStore';
import RouterStore from '../../store/RouterStore';


interface IPropsListaDeAutotexto {
}

const variaveisSV = {
    descricao: "Variáveis GE",
    "campos": [
        '${SVSIGLAORGAO}'
        , '${SVNOMEORGAO}'
        , '${SVNUMEROPROCESSOSEMSIG}'
        , '${SVCLASSESPOREXTENSO}'
        , '${SVCLASSESPOREXTENSOMAIUSCULO}'
        , '${SVNUMEROPROCESSO}'
        , '${SVORGAOJUDICANTECOLEGIADO}'
        , '${SIGLAORGAOJUDICANTECOLEGIADO}'
        , '${SVSIGLAGABINETE}'
        , '${SVPOLOATIVO}'
        , '${SVPOLOPASSIVO}'
        , '${SVPOLOATIVOTIPO}'
        , '${SVPOLOPASSIVOTIPO}'
        , '${DATA}'
        , '${SIGNATARIO}'
        , '${DESCSIGNATARIO}'
        , '${SVNOMEORGAODECISAO}'
        , '${SIGLAUSUARIO}'
    ]
};

const variaveisAguIA = {
    descricao: "Variáveis ÁguIA",
    "campos": [
        '${SVRELATORIOAGUIA}',
        '${SVVOTOAGUIA}'
    ]
};





class ModalDeAutotexto extends React.Component<IPropsListaDeAutotexto> {
    modalVariaveis: boolean;
    autotextos: any;

    constructor(props: IPropsListaDeAutotexto) {
        super(props);
        this.modalVariaveis = false;
        this.autotextos = undefined;
        makeObservable(this, {
            modalVariaveis: observable,
            autotextos: observable,
            abrirModal: action,
            fecharModal: action
        });
    }

    abrirModal = () => {
        this.modalVariaveis = true;
    }

    fecharModal = () => {
        this.modalVariaveis = false;
    };

    componentDidMount() {
        // Precisa ser síncrono (não pode retornar Promise): em React 19 + mobx-react 9,
        // um componentDidMount `async` quebra permanentemente a reatividade do observer().
        (async () => {
            let autotextos = await AutotextosService.recuperarAgrupados();
            autotextos = this.filtrarAutoTextos(autotextos);
            const result = [];
            autotextos?.forEach((autotexto, index) => {
                const resultCampos = [];
                result.push({ descricao: autotexto.descricao, campos: [] });
                autotexto.campos?.forEach((campo) => {
                    resultCampos.push('$' + campo.descricao);
                });
                result[index].campos = [];
                result[index].campos = resultCampos;
            });
            result.push(variaveisSV);
            if (!RouterStore.isPrd) {
                result.push(variaveisAguIA);
            }

            const infoTST = result.find(item => item.descricao === "Informações do TST");
            if (infoTST) {
                infoTST.campos.push("${##SVACORDAOPELOPJE}", "${##ACORDAOSTSTPELOPJE}");
            }

            const infoRegional = result.find(item => item.descricao === "Informações do Regional");
            if (infoRegional) {
                infoRegional.campos.push("${##DESPACHOADMISSIBILIDADETRTPELOPJE}");
            }

            runInAction(() => {
                this.autotextos = result;
            });
        })();
    }

    filtrarAutoTextos(autotextos) {
        const retorno = [];
        autotextos.forEach(autotexto => {
            if (!autotexto.descricao.includes('Informações Voto Assistido') &&
                !autotexto.descricao.includes('Informações do Tema') &&
                !autotexto.descricao.includes('Autotexto')) {
                retorno.push(autotexto);
            }
        });
        return retorno;
    }

    renderizarItensDeListaDeAutotexto(autotexto) {
        return autotexto.campos?.map((valor, id) => {
            return (
                <ListItem className="descricaoAutotexto" key={`descricaoAutotexto_+${id}`} >
                    {valor}
                    <CopyToClipboard text={valor} onCopy={() => MensagemStore.apresentarMensagem('Variável copiada com sucesso.')}>
                        <Tooltip title={'Copiar ' + valor}>
                            <IconButton size='small' className='icone-small'>
                                <FileCopy />
                            </IconButton>
                        </Tooltip>
                    </CopyToClipboard>
                </ListItem>
            );
        });
    }

    render() {
        return (
            <>
                <Button variant='contained' onClick={this.abrirModal}>
                    Variáveis
                </Button>
                <Modal
                    aberto={this.modalVariaveis}
                    fecharModal={this.fecharModal}
                    funcaoAcaoSecundaria={this.fecharModal}
                    labelAcaoSecundaria='Fechar'
                    titulo={<div style={{ textAlign: 'center', width: '100%' }}>Variáveis de modelo</div>}
                    maxWidth={false}
                >
                    <Paper >
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(4, 1fr)',
                                gap: '24px',
                                maxHeight: '65vh',
                                overflowY: 'auto',
                                padding: '16px',
                                boxSizing: 'border-box',
                            }}
                        >
                            {this.autotextos?.map((autotexto) => (
                                <List key={`autotexto_${autotexto.descricao}`}>
                                    {autotexto.filhos ? (
                                        autotexto.filhos.map((filho) => (
                                            <div key={`filho_${filho.descricao}`}>
                                                <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '10px' }}>
                                                    <b>{filho.descricao}</b>
                                                </div>
                                                <div style={{ maxHeight: '58vh', overflowY: 'auto' }}>
                                                    <ListItem title={autotexto.descricao} key={`listItem_${filho.descricao}`}>
                                                        <List className="FilhosAutotexto">
                                                            {this.renderizarItensDeListaDeAutotexto(filho)}
                                                        </List>
                                                    </ListItem>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div key={`autotextoSemFilhos_${autotexto.descricao}`}>
                                            <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '10px' }}>
                                                <b>{autotexto.descricao}</b>
                                            </div>
                                            <div>
                                                {this.renderizarItensDeListaDeAutotexto(autotexto)}
                                            </div>
                                        </div>
                                    )}
                                </List>
                            ))}
                        </div>
                    </Paper>
                </Modal>
            </>
        );
    }
}

export default observer(ModalDeAutotexto);